/* eslint-disable camelcase */
import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export const SidebarSection = styled(Row)`
  padding: 10px 0px 10px 0px;
`
